import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const OrderRequestViewChunk = React.lazy(() =>
  import('../feature-sets/OrderRequestView').then(({ OrderRequestView }) => ({
    default: OrderRequestView,
  }))
)

const LegacyOrderRequestViewChunk = React.lazy(() =>
  import('../feature-sets/LegacyOrderRequestView').then(
    ({ LegacyOrderRequestView }) => ({
      default: LegacyOrderRequestView,
    })
  )
)

export const OrderRequestPage = () => {
  const intl = useProcurifyIntl()
  const PUR_3180_NEXT_GEN_INTAKE_REDESIGN = useFeatureFlag(
    'PUR_3180_NEXT_GEN_INTAKE_REDESIGN'
  )

  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.createOrderRequestPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.orderStatusPageTitle),
          link: url('OrderStatusPage', { status: 'pending' }),
        },
        {
          name: intl.formatMessage(messages.orderRequestPageTitle),
        },
      ]}
    >
      {PUR_3180_NEXT_GEN_INTAKE_REDESIGN ? (
        <OrderRequestViewChunk />
      ) : (
        <LegacyOrderRequestViewChunk />
      )}
    </Page>
  )
}
